<template>
    <div class="show-label">
        <base-label
            v-if="item.isLifetime && isAllowed('lifetime')"
            class="is-green is-large"
        >
            Lifetime
        </base-label>
        <base-label
            v-if="item.isFrozen && isAllowed('frozen')"
            class="is-red is-large"
        >
            Frozen
        </base-label>
        <base-label
            v-if="isAllowed('plan')"
            :class="[
                'is-large',
                {
                    'is-gray': item.plan.isFree,
                    'is-green': !item.plan.isFree,
                }
            ]"
        >
            {{ item.plan.name }}
        </base-label>
        <base-label
            v-if="item.hosted && isAllowed('hosted')"
            class="is-purple is-large"
        >
            Hosted
        </base-label>

        <base-label
            v-if="currentSubscription && currentSubscription.ends_at && isAllowed('canceled')"
            class="is-gray is-large"
        >
            Canceled
        </base-label>
    </div>
</template>
<script>
import { isEmpty } from 'lodash';
import { mapState } from 'vuex';

export default {
    props: {
        item: {
            type: Object,
            required: true,
        },
        allowedLabels: {
            type: Array,
            default: null,
        },
    },

    computed: {
        ...mapState(['currentSubscription']),
    },

    methods: {
        /**
         * Determines whether label is allowed to show or not.
         *
         * @param   {string}  label Label name.
         * @returns {boolean}       Show label or not?
         */
        isAllowed(label) {
            return isEmpty(this.allowedLabels) ? true : this.allowedLabels.includes(label);
        },
    },
};
</script>
